<script setup>

  const props = defineProps({
    filtro: Object
  })


  // Añadimos el campo repetición extra
  props.filtro.value_confirmacion = null;
  
</script>

<template>
  <div class="w-full my-3 flex space-x-4 items-center border-b pb-4">
    <div class="w-3/12 font-bold text-right">{{ filtro.nombre }}</div>
    <div class="w-9/12">
      <input type="email"
            v-model="filtro.value"
            :name="'filtros_default['+filtro.nombre_bd+']'" 
            :id="'filtros_default_'+filtro.nombre_bd" 
            placeholder="" 
            :class="{ 'error-validate' : filtro.error }"
            class="input-f">
    </div>
  </div>
  
  <div class="w-full flex space-x-4 items-center border-b pb-4">
    <div class="w-3/12 font-bold text-right">Confirmación {{  filtro.nombre }}</div>
    <div class="w-9/12">
      <input type="email" 
            v-model="filtro.value_confirmacion"
            :name="'filtros_default['+filtro.nombre_bd+'_confirmacion]'" 
            :id="'filtros_default_'+filtro.nombre_bd+'_confirmacion'"
            placeholder=""
            :class="{ 'error-validate' : filtro.error }" 
            class="input-f">
    </div>
  </div>
</template>

<style lang="scss">
  .error-validate {
    border: 1px solid #CC0000;
  }
</style>

